'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
const usePaymentPermissions = tree => {
  const $ = _c(2);
  let t0;
  if ($[0] !== tree) {
    t0 = (paymentMethodTypeHandle, transactionTypeHandle, assetHandle) => {
      const method = tree.find(t1 => {
        const {
          handle
        } = t1;
        return handle === paymentMethodTypeHandle;
      });
      if (!method) {
        return false;
      }
      const transactionType = method.children.find(t2 => {
        const {
          handle: handle_0
        } = t2;
        return handle_0 === transactionTypeHandle;
      });
      if (!transactionType) {
        return false;
      }
      const asset = transactionType.children.find(t3 => {
        const {
          handle: handle_1
        } = t3;
        return handle_1 === assetHandle;
      });
      if (!asset) {
        return false;
      }
      return !!asset.status;
    };
    $[0] = tree;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasPaymentPermission = t0;
  return hasPaymentPermission;
};
export default usePaymentPermissions;